import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import Industries from "@/pages/Industries";
import BookDemo from "@/pages/BookDemo";
import Leads from "@/pages/Leads";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App font-sans bg-[#EDF1F6] text-brand-ink antialiased min-h-screen">
      <BrowserRouter>
        <ScrollManager />
        <div className="max-w-[1440px] mx-auto sm:px-4 lg:px-6 sm:py-4">
          <div className="bg-white sm:rounded-[2.5rem] overflow-clip shadow-2xl shadow-slate-900/5">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/industries" element={<Industries />} />
                <Route path="/book-demo" element={<BookDemo />} />
                <Route path="/leads" element={<Leads />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </div>
        <ChatWidget />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
